import type { CServicesTranslations } from "./pl";

export const de: CServicesTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Dienstleistungen zum Anzeigen.",
  readMore: "Dienstleistung ansehen",
  inPreparationBadge: "In Vorbereitung",
};
